import React from "react";
import axios from "axios"
import { toast, } from 'react-toastify';
import withStyles from "@material-ui/core/styles/withStyles";
import Emailicon from "../../assets/img/email.png";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import Menu from "../Menu";
import Menu1 from "../Menu1";
import { Link } from "react-router-dom";
import ForgotPasswordStyle from './ForgotPasswordStyle'
import image from "../../assets/img/login_bg.png";
import { BASE_URL } from "../../utils/handleApi";

const validEmailRegex = RegExp(
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

class ForgotPassword1 extends React.Component {
  state = {
    email: "",
    errors: {
      email: "",
    },
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const { errors } = this.state;
 
    switch (name) {
      case "email":
          errors.email = validEmailRegex.test(value) ? "" : "Please enter valid email address!";
          break;
      default:
          break;
    }
    this.setState({ errors, [name]: value });
  };

  handleKeyDown = (e) => {
    if(e.keyCode === 32){
      e.preventDefault();
    }
  }

  validateError = () => {
    let hasError = false;
    let errors = this.state.errors || {};

    if(!this.state.email){
      errors.email = "Please enter Email Address";
    } else if(!validEmailRegex.test(this.state.email)){
      errors.email = "Please enter valid email address!";
    } else {
      errors.email = ""
    }

    this.setState({ errors });
    
    for (const value of Object.values(errors)) {
      if(value.length > 0)
        hasError = true
      else
        hasError = false
    }
    return hasError;
  }

  handleLogin = () => {
    if (!this.validateError(this.state.errors)) {
      axios.post(`${BASE_URL}/vendor/forgotPassword`, {
        email_address: this.state.email.toLowerCase(),
      })
      .then(() => {
          toast.success('OTP has been sent to your entered email address, please check.')
          this.props.history.push({ pathname: '/Otp', state: this.state.email })
      })
      .catch((err) => {
        if(err.response.status === 404){
          toast.error('Entered email does not exist in our system')
        }
      });
        
    } 
  }
  
  render() {
    const { classes } = this.props;
    const { errors } = this.state;
    return (
      <div>
        {localStorage.getItem('token', this.props.data) ? <Menu /> : <Menu1 />}
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
          }}
        >
          <div className={classes.container}
            style={{marginTop:"4%"}}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={4}>
                  <Card className={classes.card}>
                    <form className={classes.form} onSubmit={this.handleLogin} noValidate>
                      <CardHeader
                        color="success"
                        signup
                        className={classes.cardHeader}
                      >
                        <h4 className={classes.cardTitle}>Forgot Password</h4>
                        <div className={classes.socialLine}></div>
                      </CardHeader>

                      <CardBody style={{ marginTop: "30px" }} signup>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <img
                            style={{ height: "4vh", marginTop: "3.5vh" }}
                            src={Emailicon}
                            alt="Pic"
                          />
                          <input
                            style={{marginTop:"18px", fontSize: "16px"}}
                            className={classes.input}
                            type="email"
                            name="email"
                            placeholder="Email..."
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeyDown}
                          />
                        </div>
                        {errors.email.length > 0 && (
                          <span style={{ display:"flex",justifyContent:"flex-start",paddingLeft:"13%",marginTop:"3px",fontSize:"12px",color:"red"}} >{errors.email}</span>
                        )}
                      </CardBody>
                      <div style={{margin:"20px 40px",paddingBottom:'15px'}}className={classes.textCenter}>
                      <Link to="/Login"><Button  style={{outline:"none"}} outline="none"color="success" className={classes.button}>
                        PREV
                      </Button>
                      </Link>
                     <Button disabled={!this.state.email} onClick={this.handleLogin} style={{outline:"none"}} outline="none"color="success" className={classes.button}>
                        NEXT
                      </Button>
                     
                    </div>
                  </form>
                </Card>
              </GridItem>
              
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(ForgotPasswordStyle)(ForgotPassword1);
